import {
    GET_ALL_STATIC_PAGES,
    GET_SINGLE_STATIC_PAGE,
    RESPONSE_STATUS,
    GET_ALL_TABLE_VALUES,
    GET_ALL_GROUP_TABLE_VALUES,
    CLEAR_RESPONSE,
    GET_ALL_BID_INCREMENTS,
    GET_SINGLE_BID_INCREMENT,
    GET_FETCH_DATA,
    SEARCH_TABLE,
    GET_ALL_GLOBAL_CUSTOM_DATA,
    GET_WITHDRAWAL_REQUEST,
    POST_WITHDRAWAL_REQUEST,
    FETCH_AUDIT_TRAIT,
    GET_MATCH_WON_PRICE,
    GET_USER_ADDRESS_DETAIS,
    GET_CIGARS_UPLOADS,
    GET_SERIAL_CHECK,
    CLEAR_SERIAL_CHECK,
} from './settingTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_STATIC_PAGES:
            return {
                ...state,
                configurations: action.payload,
            }
        case GET_FETCH_DATA:
            return {
                ...state,
                search_fetch_data: action.payload,
            }
        case GET_SINGLE_STATIC_PAGE:
            return {
                ...state,
                single_configuration: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_ALL_BID_INCREMENTS:
            return {
                ...state,
                bid_increments: action.payload,
            }
        case GET_SINGLE_BID_INCREMENT:
            return {
                ...state,
                single_bid_increment: action.payload,
            }
        case GET_CIGARS_UPLOADS:
            return {
                ...state,
                cigarsUploadList: action.payload,
            }

        case SEARCH_TABLE:
            return {
                ...state,
                search_table_data: action.payload,
            }
        case GET_ALL_TABLE_VALUES:
            return {
                ...state,
                table_data: action.payload,
            }
        case GET_ALL_GROUP_TABLE_VALUES:
            return {
                ...state,
                group_table_data: action.payload,
            }
        case POST_WITHDRAWAL_REQUEST:
            return {
                ...state,
                ...action.payload,
            }
        case GET_WITHDRAWAL_REQUEST:
            return {
                ...state,
                withdrawal_data: action.payload,
            }
        case GET_MATCH_WON_PRICE:
            return {
                ...state,
                productMatchWonHigstPrice: action.payload,
            }
        case GET_ALL_GLOBAL_CUSTOM_DATA:
            return {
                ...state,
                all_global_data: action.payload,
            }
        case FETCH_AUDIT_TRAIT:
            return {
                ...state,
                audit_trial_data: action.payload,
            }
        case GET_USER_ADDRESS_DETAIS:
            return {
                ...state,
                userAddressData: action.payload,
            }
        case GET_SERIAL_CHECK:
            return {
                ...state,
                serialCheckDetails: action.payload,
            }
        case CLEAR_SERIAL_CHECK:
            return {
                ...state,
                serialCheckDetails: {},
            }
        default:
            return state
    }
}
